import { useState, useCallback } from 'react';
import { setEditors } from 'api/cansurvey/surveyApi';

interface UseEditorMutationsReturn {
  setEditorsMutation: (surveyId: number, editorEmployeeIds: number[]) => Promise<void>;
  saving: boolean;
}

export const useEditorMutations = (): UseEditorMutationsReturn => {
  const [saving, setSaving] = useState(false);

  const setEditorsMutation = useCallback(
    async (surveyId: number, editorEmployeeIds: number[]) => {
      setSaving(true);
      try {
        await setEditors(surveyId, editorEmployeeIds);
      } finally {
        setSaving(false);
      }
    },
    []
  );

  return { setEditorsMutation, saving };
};
